import { useAuthStore } from "@/stores/authStore";
import { useEffect } from "react";

export default function AuthProvider({
    children,
}: {
    children: React.ReactNode;
}) {
    const initialize = useAuthStore(state => state.initialize);

    useEffect(() => {
        initialize();
    }, []);

    return children;
}